<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <el-header style="margin-bottom: 2px; height:56px">
      <div :class="{'fixed-header':fixedHeader}">
        <navbar />
        <!-- <tags-view v-if="needTagsView" /> -->
      </div>
    </el-header>
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <!-- <breadcrumb class="breadcrumb-container" /> -->
      <!-- <check-module /> -->
      <app-main />
    </div>
    <ReviewResultModal ref="reviewResultModal" />
    <modify-login-pwd-modal ref="loginPwdModalRef" />
  </div>
</template>

<script>
import AppMain from './components/ezpay/AppMain'
import Sidebar from './components/ezpay/Sidebar'
import Navbar from './components/ezpay/Navbar'
import ResizeMixin from './mixin/ResizeHandler'
import ReviewResultModal from './components/Modal/ReviewResultModal'
import ModifyLoginPwdModal from '@/views/paycools/system/components/ModifyPwdModal.vue'
// import Breadcrumb from '@/components/Breadcrumb'

export default {
  name: 'Layout',
  components: {
    ModifyLoginPwdModal,
    ReviewResultModal,
    Navbar,
    // Breadcrumb,
    Sidebar,
    AppMain
    // TagsView,
    // CheckModule
  },
  mixins: [ResizeMixin],
  // 声明遍历
  data() {
    return {
    }
  },
  computed: {
    needTagsView() {
      return this.$store.state.settings.tagsView
    },
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return true
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  mounted() {
    this.$store.dispatch('user/getUnreadNotificationCount')
    const { reset_type, account_type, naire_status } = this.$store.state.user.userInfo

    // 没有重置密码跳到重置密码页面
    if (reset_type === 2 && account_type === 1) {
      this.$router.push('/systemManage/settings')
    } else if (naire_status === 2 && account_type === 1) {
      this.tipAndOpenQuestionnaireModal()
      // this.$router.push('/questionnaire')
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const toRouterName = to.name
      const allowRouters = ['Dashboard', 'System_User_Setting']
      if (allowRouters.indexOf(toRouterName) !== -1) {
        return vm
      }
      //
      const authorities = vm.$store.state.user.authorities
      const toAccessAuths = to.meta.auth ?? []

      let flag = false
      toAccessAuths.forEach(item => {
        if (authorities.indexOf(item) !== -1) {
          flag = true
        }
      })

      if (!flag) {
        // vm.$router.replace('/404')
      }

      return vm
    })
  },
  beforeRouteUpdate(to, from, next) {
    const toRouterName = to.name
    const allowRouters = ['Dashboard', 'System_User_Setting']
    if (allowRouters.indexOf(toRouterName) !== -1) {
      next()
    }

    const authorities = this.$store.state.user.authorities
    const toAccessAuths = to.meta.auth ?? []
    let flag = false
    toAccessAuths.forEach(item => {
      if (authorities.indexOf(item) !== -1) {
        flag = true
      }
    })

    if (!flag) {
      // next('/404')
    }
    next()
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    tipAndOpenQuestionnaireModal() {
      this.$alert('You must finish the Compliance Questionnaire before you activate the account', 'Tips', {
        confirmButtonText: 'Confirm',
        // cancelButtonText: 'Casssncel',
        type: 'warning'
      }).then(() => {
        this.$router.push('/questionnaire')
      }).catch(() => {
        this.tipAndOpenQuestionnaireModal()
      })
    }
  }

}
</script>

<style lang="scss" scoped>
  @import "~@/styles/ezpay/mixin.scss";
  @import "~@/styles/ezpay/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;

    // height: 100%;
    // width: 100%;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: 100%;
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: 100%
  }

  .mobile .fixed-header {
    width: 100%;
  }

  .breadcrumb-container {
    margin: 20px 0 -3px 20px;
  }
  .sidebar-container {
    -webkit-box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
    box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
  }
  .main-container{
    padding: 40px 27px 50px;
    background: #EDF2F9;
  }
</style>
